import { render, staticRenderFns } from "./ProjectTabs.vue?vue&type=template&id=294ce518&scoped=true&lang=html"
import script from "./ProjectTabs.vue?vue&type=script&lang=js"
export * from "./ProjectTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectTabs.vue?vue&type=style&index=0&id=294ce518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294ce518",
  null
  
)

export default component.exports